import { useCallback, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/shadcn/alert-dialog";

const DESTRUCTIVE_ACTION = "bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-600";

export const ConfirmNewChatDialog = ({
  open,
  onOpenChange,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Start a new chat?</AlertDialogTitle>
        <AlertDialogDescription>This chat will be deleted and can't be recovered.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction className={DESTRUCTIVE_ACTION} onClick={onConfirm}>
          Start new chat
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const useConfirmNewChat = ({
  hasMessages,
  onNewChat,
}: {
  hasMessages: boolean;
  onNewChat: () => void;
}) => {
  const [open, setOpen] = useState(false);

  const requestNewChat = useCallback(() => {
    if (hasMessages) setOpen(true);
    else onNewChat();
  }, [hasMessages, onNewChat]);

  const confirmDialog = <ConfirmNewChatDialog open={open} onOpenChange={setOpen} onConfirm={onNewChat} />;

  return { requestNewChat, confirmDialog };
};
